export const useDocumentContainerWrapperHeight = () => {
  try {
    var documentContainerElement = document.getElementById(
      "document-container-wrapper"
    );
    if (!documentContainerElement) {
      return 0;
    }

    var documentBox = documentContainerElement.getBoundingClientRect();

    if (documentBox == undefined || documentBox.height == undefined) return 0;

    return documentBox.height;
  } catch (error) {
    return 0;
  }
};
